




































































































import { localISO } from "@/utils/localDate";
import { Component, Vue, Prop } from "vue-property-decorator";

const MOMENTS = [
  { code: "m1", short: "Sblm pasien", label: "Sebelum menyentuh pasien" },
  { code: "m2", short: "Sblm aseptik", label: "Sebelum tindakan aseptik" },
  { code: "m3", short: "Stlh cairan", label: "Setelah terkena/berisiko terkena cairan tubuh pasien" },
  { code: "m4", short: "Stlh pasien", label: "Setelah menyentuh pasien" },
  { code: "m5", short: "Stlh lingk.", label: "Setelah menyentuh lingkungan di sekitar pasien" }
];

const ACTIONS = [
  {
    code: "hr",
    short: "Handrub",
    color: "success",
    icon: "mdi-hand-wash-outline",
    label: "Handrub — kebersihan tangan dengan cairan berbasis alkohol"
  },
  {
    code: "hw",
    short: "Handwash",
    color: "info",
    icon: "mdi-water",
    label: "Handwash — cuci tangan dengan sabun dan air mengalir"
  },
  {
    code: "tdk",
    short: "Tidak",
    color: "error",
    icon: "mdi-close",
    label: "Tidak melakukan kebersihan tangan pada moment tersebut"
  }
];

const KATEGORI = [
  { code: "dokter", label: "Dokter" },
  { code: "perawat", label: "Perawat" },
  { code: "bidan", label: "Bidan" },
  { code: "ppa_lain", label: "PPA Lain" },
  { code: "petugas_medis_lain", label: "Petugas Medis Lain" },
  { code: "tenaga_penunjang", label: "Tenaga Penunjang" },
  { code: "mahasiswa", label: "Mahasiswa" },
  { code: "cleaning_service", label: "Cleaning Service" }
];

@Component
export default class MomentActionKeypad extends Vue {
  @Prop({ type: Number, default: 0 }) pendingCount!: number;

  selectedMoment: string | null = null;
  selectedAction: string | null = null;
  selectedKategori: string | null = null;
  tindakan: string | null = null;

  moments = MOMENTS;
  actions = ACTIONS;
  kategoriOptions = KATEGORI;

  get canCommit() {
    return !!this.selectedMoment && !!this.selectedAction && !!this.selectedKategori;
  }

  selectMoment(code: string) {
    this.selectedMoment = code;
  }

  selectAction(code: string) {
    this.selectedAction = code;
  }

  commit() {
    if (!this.canCommit) return;
    const tindakan = (this.tindakan || "").trim();
    this.$emit("commit", {
      waktu_observasi: localISO().slice(0, 19).replace("T", " "),
      moment: this.selectedMoment,
      action: this.selectedAction,
      kategori_petugas: this.selectedKategori,
      catatan: tindakan || null
    });
    this.selectedMoment = null;
    this.selectedAction = null;
    // tindakan & kategori sengaja dipertahankan: satu tindakan lazim menghasilkan beberapa aksi
  }

  mounted() {
    window.addEventListener("keydown", this.onKeyDown);
  }

  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  }

  onKeyDown(e: KeyboardEvent) {
    const tag = (e.target as HTMLElement).tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return;
    const key = e.key.toLowerCase();
    if (["1", "2", "3", "4", "5"].includes(key)) {
      this.selectMoment("m" + key);
    } else if (key === "r") {
      this.selectAction("hr");
    } else if (key === "w") {
      this.selectAction("hw");
    } else if (key === "t") {
      this.selectAction("tdk");
    } else if (key === "enter" && this.canCommit) {
      this.commit();
    }
  }
}
